import { Injectable } from "@angular/core";
import { PageableResult } from "src/app/ui/models/domains/paginator/pageable-result";
import { AbstractParser } from "../../parser";
import { parsePdvFinancialStatementList } from "./network-parse-functions";

@Injectable()
export class SearchNetworkFinancialStatementsParse extends AbstractParser<PageableResult> {
  parse(payload: any): PageableResult {
    const pageableResult = new PageableResult();
    pageableResult.setStart(payload.Start);
    pageableResult.setEnd(payload.TotalPerPages);
    pageableResult.setTotalItems(payload.Total);
    pageableResult.setItems(parsePdvFinancialStatementList(payload.Data));
    return pageableResult;
  }
}
